import {
	Alert,
	Box,
	Button,
	FormControlLabel,
	Grid,
	Link,
	Switch,
	Typography,
} from '@barracuda-internal/bds-core-v2';
import React, { ReactElement, useState } from 'react';
import { useApiRequest } from 'src/hooks/useApi';
import { useAppToolchain } from 'src/hooks/useAppToolchain';

function RequestPIConsent({ setStep, activeStep }): ReactElement {
	const [consent, setConsent] = useState(true);
	const [doConsent, setDoConsent] = useState(false);
	const [first, setFirst] = useState(false);
	const { api } = useAppToolchain();

	const [updateStatus, req, error] = useApiRequest(
		doConsent &&
			(() =>
				api.updateUserConfig('current', [
					{
						path: '/personalInfoCollectionConsented',
						op: 'replace',
						value: consent,
					},
				])),
		[doConsent],
		() => {
			localStorage.setItem('is_setup','true')
			setStep(activeStep + 1);
			setDoConsent(false);
		},
	);

	useApiRequest(
		(signal) => api.getLoggedInUser({ signal }),
		[first],
		(resp) => {
			let user = resp[1];
			if(user.config.personalInfoCollectionConsented != null) {
				setConsent(user.config.personalInfoCollectionConsented);
			}else {
				setConsent(false);
			}
		},
	);

	let handleChange = (e, checked) => {
		setConsent(checked);
	};
	let handleNext = () => {
		setDoConsent(true);
	};

	return (
		<Box>
			<Typography
				variant="h1"
				color="textPrimary"
				gutterBottom
				sx={{ marginTop: '32px' }}
			>
				Personal Information consent
			</Typography>
			{error ? (
				<Alert severity="error">
					There was an error saving the form. Please try again.
				</Alert>
			) : null}
			{!consent ? (
				<Alert severity="warning">
					<Typography
						variant="body2"
						color="textPrimary"
						sx={{ marginBottom: '8px' }}
					>
						You did not consent to the Barracuda personal
						information agreement. You may miss out on full product
						support and communications.
					</Typography>
					<Typography
						variant="body2"
						color="textPrimary"
						sx={{ marginBottom: '8px' }}
					>
						You can update your consent under Data settings later or
						accept now.
					</Typography>
				</Alert>
			) : null}
			<Box sx={{ marginTop: '32px' }}>
				<Grid container spacing={1}>
					<Grid item xs={3}>
						<FormControlLabel
							control={
								<Switch
									name="checkedB"
									color="primary"
									onChange={handleChange}
									checked={consent}
								/>
							}
							label="Accepted"
							sx={{ gap: '8px', marginLeft: 0 }}
						/>
					</Grid>
					<Grid item xs={9}>
						<Typography
							variant="body1"
							color="textPrimary"
							sx={{ marginBottom: '16px' }}
						>
							Barracuda Data Inspector can collect your name and
							email address for the purpose of providing product
							support and communicating product news and
							announcements.
						</Typography>
						<Typography
							variant="body1"
							color="textPrimary"
							sx={{ marginBottom: '16px' }}
						>
							Please see our{' '}
							<Link
								href="https://www.barracuda.com/company/legal/trust-center/data-privacy"
								target="_blank"
								rel="noopener noreferrer"
							>
								Trust Center
							</Link>{' '}
							for information on how we keep your data secure.
						</Typography>
					</Grid>
				</Grid>
				<Box sx={{ marginTop: '24px' }}>
					<Grid container direction="row" spacing={1}>
						<Grid item xs={8}></Grid>
						<Grid item xs={2}>
							<Button
								onClick={() => setStep(activeStep - 1)}
								bdsType="interactiveSubtle"
							>
								Back
							</Button>
						</Grid>
						<Grid item xs={2}>
							<Button onClick={handleNext}>
								Next
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Box>
	);
}

export default RequestPIConsent;
